<template>
  <div class="app-warp">
    <slot name="header">
      <app-header v-if="$route.query.inApp!=3||$route.query.isShowTitle"></app-header>
    </slot>
    <div class="app-content" :style="contentStyle">
      <slot></slot>
    </div>
    <div class="app-footer" slot="app-footer"></div>
  </div>
</template>

<script>
    import AppHeader from './Header';
    import { mapGetters } from "vuex";
    export default {
        name: 'app-main',
        components: {
          AppHeader
        },
        data() {
            return {
              contentStyle: {
                paddingTop: "0.70rem",
                height:""
              },
            }
        },
        computed: {
          ...mapGetters({
            inApp: "inApp"
          })
        },
        mounted() {
          this.$nextTick(() => {
            this.setSystem();
          });
        },
        methods:{
          setSystem(){
            let height = this.$route.query.statusBarH;
            if (this.checkInApp() == 'h5') {
              // this.contentStyle.paddingTop = "calc(0.59rem" + " + 0.65rem" + ")"
              this.contentStyle.paddingTop = "0.6rem"
            } else if (this.checkInApp() == 'wechat') {
              // this.contentStyle.paddingTop = "calc(.8rem)"
              this.contentStyle.paddingTop = "0"
            } else if (this.checkInApp() == 'app') {
              this.contentStyle.paddingTop = "calc(0.59rem" + " + " + height + "px)"
            }
          },
          checkInApp() {
            if(this.getQueryString('inApp') == 0 || this.getQueryString('inApp') == false){
              return 'h5'
            } else if (this.getQueryString('inApp') == 3){
              return 'wechat'
            } else {
              return 'app'
            }
          },
          getQueryString(variable){
            if (this.$route.query[variable]) {
              return this.$route.query[variable]
            }
            return false
          }
        }
    }
</script>

<style lang="scss" scoped >
  .app-warp {
    .app-content {
      height: 100vh;
    }
  }
</style>
